export default __webpack_public_path__ + "static/02-876d199452983715ab20c4755e6a702e.png";